"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invert = invert;
var color_1 = require("../../color");
/**
 * Inverts a color.
 * @param color - The color to invert.
 * @returns A new Color instance with inverted RGB values.
 */
function invert(color) {
    var _a = color.toRgb(), r = _a.r, g = _a.g, b = _a.b, a = _a.a;
    return new color_1.Color({ r: 255 - r, g: 255 - g, b: 255 - b, a: a });
}
